<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'scheduling.parentTitle' | translate }}"></app-page-header>
  </div>
  <div class="row">
    <div class="col-lg-5 col-xl-5 col-sm-12">
      <div class="component-forms-box">
        <!-- Sessão de criação de agendamentos -->
        <div class="form-fields-box" [ngClass]="!createSchedulingBox ? 'closed' : ''">
          <h2 (click)="createSchedulingBoxOpen()">
            {{ "scheduling.create-scheduling-form" | translate }}
          </h2>
          <hr [ngClass]="!createSchedulingBox ? 'hr-open' : ''" />
          <mat-vertical-stepper [linear]="true" #stepper>
            <mat-step label="{{
                'scheduling.filter-installations-gateways-label' | translate
              }}" [stepControl]="schedulingForm">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{
                      "scheduling.filter-installations-gateways-title"
                      | translate
                      }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <form [formGroup]="schedulingForm">
                    <div class="form-step">
                      <p>
                        <mat-slide-toggle (change)="setFullCoverage($event)">
                          {{ "scheduling.set-full-coverage" | translate }}
                        </mat-slide-toggle>
                      </p>
                    </div>

                    <br />
                    <div class="form-step">
                      <mat-form-field appearance="outline">
                        <mat-label>{{
                          "scheduling.search-installation-input" | translate
                          }}
                        </mat-label>
                        <input matInput formControlName="installationReference" #referenceInstallation />
                        @if (!isInstallationLoadingCreateScheduling) {
                        <mat-icon class="component-search-icon" (click)="
                            filterInstallations(referenceInstallation.value)
                          " svgIcon="bx-search"></mat-icon>
                        }
                      </mat-form-field>
                    </div>
                    <!-- Loading -->
                    @if (isInstallationLoadingCreateScheduling) {
                    <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
                    }

                    @if (installationList.length > 0) {
                    <div class="form-step">
                      <mat-form-field appearance="outline">
                        <mat-label>{{
                          "scheduling.select-installation-input" | translate
                          }}
                        </mat-label>
                        <mat-select multiple formControlName="installationSelected">
                          @for (installation of installationList; track installation) {
                          <mat-option [value]="installation.id" (onSelectionChange)="
                              saveInstallationsSelected($event, installation)
                            ">
                            {{ installation.reference }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    }

                    <div class="form-step">
                      <mat-form-field appearance="outline">
                        <mat-label>
                          {{ "scheduling.search-gateway-input" | translate }}
                        </mat-label>
                        <input matInput formControlName="gatewayReference" #referenceGateway />
                        @if (!isGatewaysLoadingFilter) {
                        <mat-icon class="component-search-icon" (click)="filterGateways(referenceGateway.value)"
                          svgIcon="bx-search"></mat-icon>
                        }
                      </mat-form-field>
                    </div>
                    <!-- Loading -->
                    @if (isGatewaysLoadingFilter) {
                    <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
                    }

                    @if (gatewayList.length > 0) {
                    <div class="form-step">
                      <mat-form-field appearance="outline">
                        <mat-label>
                          {{ "scheduling.select-gateway-input" | translate }}
                        </mat-label>
                        <mat-select multiple formControlName="gatewaySelected">
                          @for (gateway of gatewayList; track gateway) {
                          <mat-option [value]="gateway.id" (onSelectionChange)="
                              saveGatewaysSelected($event, gateway)
                            ">
                            {{ gateway.reference }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    }
                    @if (
                    gatewaysSelected.length > 0 ||
                    installationsSelected.length > 0
                    ) {
                    <div class="d-flex m-2">
                      @if (gatewaysSelected.length > 0) {
                      <button class="mb-2 w-50" mat-flat-button color="primary"
                        (click)="openInstallationsGatewaysDialog('gateway')">
                        {{ "scheduling.selected-gateways" | translate }}
                      </button>
                      }
                      @if (installationsSelected.length > 0) {
                      <button class="mb-2 w-50" mat-flat-button color="primary" (click)="
                          openInstallationsGatewaysDialog('installation')
                        ">
                        {{ "scheduling.selected-installations" | translate }}
                      </button>
                      }
                    </div>
                    }
                    <br />

                    <ng-template #dialogTemplate let-dialogRef="dialogRef">
                      @if (selectedDialogType === 'installation') {
                      <div class="dialogRef">
                        @if (installationsSelected.length > 0) {
                        <h2 mat-dialog-title>
                          {{ "scheduling.selected-installations" | translate }}
                        </h2>
                        }
                        <mat-dialog-content class="mat-typography">
                          @if (installationsSelected.length < 1) { <span>
                            {{
                            "scheduling.no-installations-selected" | translate
                            }}
                            </span>
                            }
                            <mat-chip-set #chipGrid>
                              @for (installation of installationsSelected; track installation) {
                              <mat-chip [value]="installation" (removed)="removeInstallationOption(installation)"
                                [removable]="true">
                                {{ installation.reference }}
                                <button matChipRemove [attr.aria-label]="'remove '">
                                  <mat-icon>cancel</mat-icon>
                                </button>
                              </mat-chip>
                              }
                            </mat-chip-set>
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                          <button mat-flat-button color="success" mat-dialog-close>
                            OK
                          </button>
                        </mat-dialog-actions>
                      </div>
                      }
                      @if (selectedDialogType === 'gateway') {
                      <div class="dialogRef">
                        @if (gatewaysSelected.length > 0) {
                        <h2 mat-dialog-title>
                          {{ "scheduling.selected-gateways" | translate }}
                        </h2>
                        }
                        <mat-dialog-content class="mat-typography">
                          @if (gatewaysSelected.length < 1) { <span>
                            {{ "scheduling.no-gateways-selected" | translate }}
                            </span>
                            }
                            <mat-chip-set #chipGrid>
                              @for (gateway of gatewaysSelected; track gateway) {
                              <mat-chip (removed)="removeGatewayOption(gateway)" [removable]="true">
                                {{ gateway.reference }}
                                <button matChipRemove [attr.aria-label]="'remove '">
                                  <mat-icon>cancel</mat-icon>
                                </button>
                              </mat-chip>
                              }
                            </mat-chip-set>
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                          <button mat-flat-button color="success" mat-dialog-close>
                            OK
                          </button>
                        </mat-dialog-actions>
                      </div>
                      }
                    </ng-template>
                  </form>
                </mat-expansion-panel>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{
                      "scheduling.filter-installations-gateways-file-title"
                      | translate
                      }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <br />
                  <div class="container-alerts-import-file">
                    <p-button (onClick)="downloadCsvFile()" label="{{
                        'scheduling.button-download-file-template' | translate
                      }}" [rounded]="true" severity="success" icon="pi pi-download"></p-button>
                  </div>

                  <br />
                  <div class="input-group">
                    <input type="file" class="form-control" id="inputGroupFile04" [accept]="'.csv'"
                      aria-describedby="inputGroupFileAddon04" aria-label="Upload" #fileUploadSimple
                      (change)="getTextFromFile($event)" [disabled]="fullCoverageIsChecked" />
                    <br />
                    @if (!isLoadingImportFilter) {
                    <button class="btn btn-secondary" type="button" id="inputGroupFileAddon04"
                      (click)="filterInstallationsAndGatewaysFile()" [disabled]="isDisabledImportButton" type="submit">
                      {{ "scheduling.import-button" | translate }}
                    </button>
                    }
                    <br />
                  </div>
                  <div class="container-alerts-import-file">
                    @if (installationsAndGatewaysNotFound) {
                    <div class="alert alert-danger">
                      {{
                      "scheduling.gateways-installations-file-not-found-text"
                      | translate
                      }}
                    </div>
                    }
                    @if (isLoadingImportFilter) {
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    }
                    @if (isLoadingImportFilter) {
                    <p style="
                        color: red;
                        margin-right: auto;
                        margin-left: auto;
                        margin-top: 17px;
                      ">
                      {{
                      "scheduling.loading-installations-gateways-file-text"
                      | translate
                      }}
                    </p>
                    }
                  </div>

                  @if (installationsSelected.length > 0) {
                  <button class="mb-2 w-50" mat-flat-button color="primary"
                    (click)="openInstallationsGatewaysDialog('installation')">
                    {{ "scheduling.selected-installations" | translate }}
                  </button>
                  }
                  @if (gatewaysSelected.length > 0) {
                  <button class="mb-2 w-50" mat-flat-button color="primary"
                    (click)="openInstallationsGatewaysDialog('gateway')">
                    {{ "scheduling.selected-gateways" | translate }}
                  </button>
                  }
                </mat-expansion-panel>
              </mat-accordion>
              <br />
              <button mat-flat-button color="success" matStepperNext [disabled]="
                  installationsSelected.length < 1 &&
                  gatewaysSelected.length < 1 &&
                  !fullCoverageIsChecked
                ">
                {{ "scheduling.next-button" | translate }}
              </button>
            </mat-step>
            <mat-step label="{{ 'scheduling.create-scheduling-label' | translate }}"
              [stepControl]="createSchedulingForm">
              <form [formGroup]="createSchedulingForm">
                <br />
                <div class="options-scheduling">
                  <label><b>{{ "scheduling.switch-on-time" | translate }}</b></label>
                  <ngx-timepicker-field [format]="24" [defaultTime]="'00:00'" [(ngModel)]="switchOnTime"
                    [ngModelOptions]="{ standalone: true }">
                  </ngx-timepicker-field>
                </div>

                <div class="options-scheduling">
                  <label><b>{{ "scheduling.switch-off-time" | translate }}</b></label>
                  <ngx-timepicker-field [format]="24" [defaultTime]="'00:00'" [(ngModel)]="switchOffTime"
                    [ngModelOptions]="{ standalone: true }">
                  </ngx-timepicker-field>
                </div>

                <div class="options-scheduling">
                  <label id="example-name-label" class="example-name-label">
                    <b>{{ "scheduling.dimming" | translate }}</b>
                  </label>

                  <mat-slider class="example-margin" min="0" max="100" showTickMarks discrete style="width: 50%">
                    <input matSliderThumb [(ngModel)]="dimmingValue" [ngModelOptions]="{ standalone: true }" />
                  </mat-slider>
                </div>

                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ "scheduling.advanced-options" | translate }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="options-scheduling">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ "scheduling.schedule-slot" | translate }}</mat-label>
                        <input matInput type="number" min="1" max="4" [(ngModel)]="scheduleSlot"
                          [ngModelOptions]="{ standalone: true }" />
                      </mat-form-field>
                    </div>
                    <div class="options-scheduling">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ "scheduling.channel" | translate }}</mat-label>
                        <input matInput type="number" min="1" max="255" [(ngModel)]="channel"
                          [ngModelOptions]="{ standalone: true }" />
                      </mat-form-field>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
                <br />

                <div>
                  @if (!isLoadingCreateSchedule) {
                  <button mat-flat-button (click)="createParkSchedule()" color="primary">
                    {{ "scheduling.send-button" | translate }}
                  </button>
                  }
                  @if (isLoadingCreateSchedule) {
                  <mat-spinner [diameter]="30"></mat-spinner>
                  }
                </div>
                <br />

                <div>
                  <button style="margin-right: 4px" mat-flat-button color="success" matStepperPrevious>
                    {{ "scheduling.previous-button" | translate }}
                  </button>
                </div>
              </form>
            </mat-step>
          </mat-vertical-stepper>
        </div>
        <!-- Sessão de filtro de agendamentos -->
        <div class="form-fields-box" [formGroup]="filterSchedulingForm"
          [ngClass]="!filterSchedulingBox ? 'closed' : ''">
          <h2 (click)="filterSchedulingBoxOpen()">
            {{ "scheduling.filter-scheduling-label" | translate }}
          </h2>
          <hr [ngClass]="!filterSchedulingBox ? 'hr-open' : ''" />
          <div class="form-step">
            <mat-form-field class="parameter" appearance="outline">
              <mat-label>{{ "scheduling.filter-status" | translate }}</mat-label>
              <mat-select formControlName="status">
                <mat-option class="form-control" value="pending">
                  {{ "scheduling.status-pending" | translate }}
                </mat-option>
                <mat-option class="form-control" value="processing">
                  {{ "scheduling.status-processing" | translate }}
                </mat-option>
                <mat-option class="form-control" value="success">
                  {{ "scheduling.status-success" | translate }}
                </mat-option>
                <mat-option class="form-control" value="fail">
                  {{ "scheduling.status-fail" | translate }}
                </mat-option>
                <mat-option class="form-control" value="partial">
                  {{ "scheduling.status-partial" | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{ "scheduling.filter-request-id" | translate }}</mat-label>
              <input matInput formControlName="requestId" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{ "scheduling.filter-created-by" | translate }}</mat-label>
              <input matInput formControlName="createdBy" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="date-picker-input">
              <p-datepicker formControlName="dateGte" appendTo="body"
                placeholder="{{ 'scheduling.filter-date-gte' | translate }}"
                showIcon iconDisplay="input" dateFormat="dd/mm/yy" />
            </div>
          </div>

          <div class="form-step">
            <div class="date-picker-input">
              <p-datepicker formControlName="dateLte" appendTo="body"
                placeholder="{{ 'scheduling.filter-date-lte' | translate }}"
                showIcon iconDisplay="input" dateFormat="dd/mm/yy" />
            </div>
          </div>

          <div class="d-flex m-2">
            @if (!isLoadingFilterScheduling) {
            <button class="btn btn-success m-1 w-50" (click)="filterScheduling(null)">
              {{ "scheduling.filter-button" | translate }}
            </button>
            }

            @if (!isLoadingFilterScheduling) {
            <button (click)="clearSchedulingFilterForm()" class="btn btn-secondary m-1 w-50">
              {{ "scheduling.button-clean-filter" | translate }}
            </button>
            }
          </div>
          @if (isLoadingFilterScheduling) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>
    <!-- Sessão da tabela. -->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-7 col-sm-7">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="isFileLoading">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        @if (length > 0) {
        <p-table [value]="ELEMENT_DATA" [columns]="displayedColumns" dataKey="requestId" [paginator]="true"
          [rows]="pageSize" [totalRecords]="length" [first]="first" (onPage)="pageChanged($event)"
          [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="switchOnTime" style="width: 10rem">
                {{ "scheduling.column-switch-on" | translate }}
              </th>
              <th pSortableColumn="switchOffTime" style="width: 10rem">
                {{ "scheduling.column-switch-off" | translate }}
              </th>
              <th pSortableColumn="dimming" style="width: 10rem">
                {{ "scheduling.column-dimming" | translate }}
              </th>
              <th pSortableColumn="status" style="width: 10rem">
                {{ "scheduling.column-status" | translate }}
              </th>
              <th pSortableColumn="totalInstallations" style="width: 10rem">
                {{ "scheduling.column-total-installations" | translate }}
              </th>
              <th pSortableColumn="successCount" style="width: 10rem">
                {{ "scheduling.column-success" | translate }}
              </th>
              <th pSortableColumn="failCount" style="width: 10rem">
                {{ "scheduling.column-fail" | translate }}
              </th>
              <th pSortableColumn="createdBy" style="width: 10rem">
                {{ "scheduling.column-createdBy" | translate }}
              </th>
              <th pSortableColumn="createdAt" style="width: 10rem">
                {{ "scheduling.column-createdAt" | translate }}
              </th>
              <th pSortableColumn="actions" style="width: 8rem">
                {{ "scheduling.column-actions" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>
                {{ row.switchOnTime }}
              </td>
              <td>
                {{ row.switchOffTime }}
              </td>
              <td>
                {{ row.dimming }}
              </td>
              <td>
                {{ ('scheduling.status-' + row.status) | translate }}
              </td>
              <td>
                {{ row.totalInstallations }}
              </td>
              <td>
                {{ row.successCount }}
              </td>
              <td>
                {{ row.failCount }}
              </td>
              <td>
                {{ row.createdBy }}
              </td>
              <td>
                {{ row.createdAt }}
              </td>
              <td>
                <p-button styleClass="btn-actions" icon="pi pi-file" [rounded]="true"
                  (click)="getSchedulingLogs(row)" />
                <p-button styleClass="btn-actions" icon="pi pi-trash" severity="danger" [rounded]="true"
                  styleClass="btn-warn" (click)="deleteScheduling(row)" pTooltip="{{ 'scheduling.delete-action' | translate }}" />
              </td>
            </tr>
          </ng-template>
        </p-table>
        }
        <!-- Sessão de logs. -->
        <p-dialog [(visible)]="isLogsSchedulingDialogOpen" [style]="{ width: '640px', maxWidth: '95vw' }"
          header="{{ 'scheduling.scheduling-logs-title' | translate }}" [modal]="true">
          <div class="commandlogs-filter">
            <mat-form-field class="parameter" appearance="outline">
              <mat-label>{{ 'scheduling.logs-filter-status' | translate }}</mat-label>
              <mat-select [(ngModel)]="commandLogsStatusFilter">
                <mat-option [value]="null">{{ 'scheduling.logs-filter-all' | translate }}</mat-option>
                <mat-option value="success">{{ 'scheduling.status-success' | translate }}</mat-option>
                <mat-option value="fail">{{ 'scheduling.status-fail' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'scheduling.logs-mac-address' | translate }}</mat-label>
              <input matInput [(ngModel)]="commandLogsMacFilter" />
            </mat-form-field>
            <div class="commandlogs-filter-actions">
              <p-button label="{{ 'scheduling.filter-button' | translate }}" (click)="applyCommandLogsFilters()"
                [disabled]="isLoadingCommandLogs" />
              <p-button label="{{ 'scheduling.button-clean-filter' | translate }}" severity="secondary"
                (click)="clearCommandLogsFilters()" [disabled]="isLoadingCommandLogs" />
            </div>
          </div>
          @if (!isLoadingCommandLogs && logsSchedulingList.length < 1) { <span>
            {{ "scheduling.scheduling-logs-not-found" | translate }}</span>
            }
            <div class="commandlogs-container">
              @for (item of logsSchedulingList; track item) {
              <div class="commandlog-card">
                <div class="commandlog-row">
                  <strong>{{ "scheduling.logs-mac-address" | translate }} </strong>{{ item.macAddress }}
                </div>
                <div class="commandlog-row">
                  <strong>{{ "scheduling.logs-serial-number" | translate }} </strong>{{ item.serialNumber }}
                </div>
                <div class="commandlog-row">
                  <strong>{{ "scheduling.logs-cmd-index" | translate }} </strong>{{ item.cmdIndex }}
                </div>
                <div class="commandlog-row">
                  <strong>{{ "scheduling.logs-status-text" | translate }} </strong>
                  @if (item.status === 'success') {
                  <p-tag icon="pi pi-info-circle" severity="success"
                    value="{{ 'scheduling.status-success' | translate }}" />
                  }
                  @if (item.status === 'fail') {
                  <p-tag icon="pi pi-info-circle" severity="danger"
                    value="{{ 'scheduling.status-fail' | translate }}" />
                  }
                </div>
                <div class="commandlog-row">
                  <strong>{{ "scheduling.logs-createdAt-text" | translate }} </strong>{{ item.createdAt }}
                </div>
                <div class="commandlog-row commandlog-command">
                  <strong>{{ "scheduling.logs-command" | translate }}</strong>
                  <pre>{{ item.command | json }}</pre>
                </div>
              </div>
              }
            </div>
            <div class="commandlogs-paginator">
              <p-button icon="pi pi-chevron-left" [rounded]="true" [text]="true" (click)="prevCommandLogsPage()"
                [disabled]="!commandLogsPagination.hasPreviousPage || isLoadingCommandLogs" />
              <span>{{ commandLogsShownCount }} / {{ commandLogsPagination.total }}</span>
              <p-button icon="pi pi-chevron-right" [rounded]="true" [text]="true" (click)="nextCommandLogsPage()"
                [disabled]="!commandLogsPagination.hasNextPage || isLoadingCommandLogs" />
            </div>
        </p-dialog>
      </div>
    </div>
    }
  </div>
</div>